import React, { useState, useRef, useEffect } from "react";
import { Flex, Typography } from "antd";
import PropTypes from "prop-types";
import styles from "./ExperienceBooking.module.css";
import { colors } from "themes/variables";

const { Text } = Typography;

const DropdownSelector = ({ label, options, value, onChange, placeholder = "Select an option", activeTab, error }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const handleOptionSelect = (option) => {
    onChange(option);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const renderOptions = () => {
    if (!options?.length) {
      return <Text>{label === "Trip Length" ? "No Trip Length" : "No Time Slots"}</Text>;
    }

    return options.map((option, index) => {
      const optionValue = label === "Trip Length" ? option?.value : option;
      const isSelected = value === optionValue;

      return (
        <button
          key={index + 1}
          type="button"
          className={`${styles.pill} ${isSelected ? styles.selected : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleOptionSelect(option);
          }}
        >
          {optionValue}
        </button>
      );
    });
  };

  return (
    <div className={styles.guestsWrapper} ref={containerRef}>
      <Flex className={`${styles.inputContainer} ${open ? styles.activeBorder : ""} ${error ? styles.errorBorder : ""}`} onClick={() => {
        if (activeTab !== 2 && activeTab !== 3) setOpen(!open);
      }}>
        <span className={styles.inputLabel}>{label}</span>
        <button
          type="button"
          className={value ? styles.selectedInputLink : styles.inputLink}
          style={{ color: activeTab === 1 ? colors.primary : colors.textSecondary }}
          onClick={() => {
            if (activeTab !== 2 && activeTab !== 3) {
              setOpen(!open);
            }
          }}
        >
          {value || placeholder}
        </button>
      </Flex>
      {error && <Text style={{ color: "red" }}>{`${label} is required.`}</Text>}

      {open && (
        <div className={styles.dropdownPanel}>
          <div className={styles.pillContainer}>{renderOptions()}</div>
        </div>
      )}
    </div>
  );
};

DropdownSelector.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  activeTab: PropTypes.number,
};

export default React.memo(DropdownSelector);
